module.exports = __webpack_public_path__ + "img/119.e716ca09.jpg";